export default "__VITE_ASSET__C5X0RYY4__"